import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { MobileTruckLoadProvider } from './MobileTruckLoadContext';
import { LoadingPortContext, LoadingPortProvider, resolvePageAccess } from '../../../context/LoadingPortContext';
import MobileHeader from './MobileHeader';
import { isMobileOrTabletDevice } from '../../common/utils';
import './mobileTruckLoad.scss';

// Header.component.js (desktop) doesn't fetch the warehouse list itself either - it
// only reads this.context.lpNames, which whichever Load Management screen is mounted
// populates by calling resolvePageAccess() on mount (getLmLoadingPorts for admins,
// checkUserCurrentPageAccess otherwise - same call, same context, same localStorage
// keys). The mobile flow has no such screen, so this loader is that call's mobile
// equivalent. Uses '/lmloadmanager' - the same url lmloadmanager.js itself resolves
// against - since these users already have access to it (that's how they reached
// Load Management to begin with).
class WarehouseDataLoader extends Component {
    static contextType = LoadingPortContext;
    componentDidMount() {
        resolvePageAccess('/lmloadmanager', this.context);
    }
    render() { return null; }
}

// Sits outside <App> (no desktop Header/Sidebar) - the mobile flow owns its own
// full-screen chrome. Renders ONE header (with its one nav sheet) here, shared
// across every mobile screen, instead of each screen re-declaring its own topbar
// like test.html did - the routed screen (this.props.children, from the <Switch>
// in index.js) only has to render its own content into the space below it.
//
// Wraps the mobile routes in one Provider instance that persists across route
// changes (this Shell doesn't unmount when the matched child <Route> changes),
// same mechanism <App> already relies on for its own ~35 nested routes. Mirrors
// <App>'s own minimal auth guard (app.jsx line ~892).
export default class MobileTruckLoadShell extends Component {
    // Login already sends a non-mobile/tablet device to /lmwelcome instead of
    // /lm-mobile/* (see Loginform.js's dashboardUrl decision), but that's only a
    // one-time choice made at login - it doesn't stop someone from opening/
    // bookmarking a /lm-mobile/* URL directly on a desktop, or resizing past the
    // threshold after already landing here. Kept live (via the resize listener
    // below) so both cases still bounce back to the desktop Load Management home
    // page, using the same isMobileOrTabletDevice check login itself uses.
    constructor(props) {
        super(props);
        this.state = { isMobileOrTablet: isMobileOrTabletDevice() };
    }

    // test.html set body{background:#eef1f6} directly - the desktop app's own
    // bootstrap.css sets body{background-color:#fff}, which otherwise still shows
    // through on the real <body> (overscroll bounce, any layout gap) since the
    // .mtl-root wrapper below is only a div inside it, not the body itself.
    componentDidMount() {
        this._previousBodyBackground = document.body.style.backgroundColor;
        document.body.style.backgroundColor = '#eef1f6';
        window.addEventListener('resize', this.onResize);
        // Being here at all means the user is genuinely in the mobile flow again -
        // re-arm app.jsx's own auto-redirect (see its mtl_desktop_override check)
        // for next time, rather than leaving a stale "go to desktop" choice from
        // an earlier MobileLanding visit still in effect.
        sessionStorage.removeItem('mtl_desktop_override');
    }

    componentWillUnmount() {
        document.body.style.backgroundColor = this._previousBodyBackground || '';
        window.removeEventListener('resize', this.onResize);
    }

    onResize = () => {
        var isMobileOrTablet = isMobileOrTabletDevice();
        if (isMobileOrTablet !== this.state.isMobileOrTablet) {
            this.setState({ isMobileOrTablet });
        }
    };

    render() {
        if (localStorage.getItem('_t') == null || localStorage.getItem('_t') == '') {
            return <Redirect to="/" push={true} />;
        }
        if (!this.state.isMobileOrTablet) {
            return <Redirect to="/lmwelcome" push={true} />;
        }
        return (
            <LoadingPortProvider>
                <WarehouseDataLoader />
                <LoadingPortContext.Consumer>
                    {(portContext) => (
                        <MobileTruckLoadProvider portCode={portContext.loading_port_code}>
                            <div className="mtl-root">
                                <div className="mtl-screen">
                                    <MobileHeader />
                                    <div className="mtl-content-area">
                                        {this.props.children}
                                    </div>
                                </div>
                            </div>
                        </MobileTruckLoadProvider>
                    )}
                </LoadingPortContext.Consumer>
            </LoadingPortProvider>
        );
    }
}
